export default "__VITE_ASSET__85e42d73__"